<template>
    <svg
        id="icon_menu_setting"
        xmlns="http://www.w3.org/2000/svg"
        width="27.235"
        height="25"
        viewBox="0 0 27.235 25"
    >
        <path
            id="Subtraction_10"
            data-name="Subtraction 10"
            d="M441.9-1865H431.348a3,3,0,0,1-2.615-1.529l-5.344-9.5a3.017,3.017,0,0,1,0-2.941l5.344-9.5a3,3,0,0,1,2.615-1.529H441.9a3,3,0,0,1,2.614,1.529l5.344,9.5a3.022,3.022,0,0,1,0,2.941l-5.344,9.5A3,3,0,0,1,441.9-1865Zm-5.277-18a5.506,5.506,0,0,0-5.5,5.5,5.506,5.506,0,0,0,5.5,5.5,5.506,5.506,0,0,0,5.5-5.5A5.506,5.506,0,0,0,436.625-1883Z"
            transform="translate(-423.007 1890)"
            fill="#fff"
        />
        <circle
            id="Ellipse_46"
            data-name="Ellipse 46"
            cx="3.5"
            cy="3.5"
            r="3.5"
            transform="translate(10.118 9)"
            fill="#fff"
        />
    </svg>
</template>
